import React, {  createContext,useState } from "react"

export const BrandContext = createContext({brand:"",setbrand:()=>{}})



function ThemeContext({children}) {

    const [brand, setbrand] = useState("")
    const mybrand=(newbrand)=>{
        setbrand(newbrand)
    }
    return (
        <BrandContext.Provider value={{brand:"bajaj",setbrand:mybrand}}>
            {children}
        </BrandContext.Provider>
    )
}

export default ThemeContext
